import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) {
      setError(error.message);
      setLoading(false);
    } else {
      navigate('/dashboard');
    }
  };

  return (
    <div data-testid="login-page" className="min-h-screen bg-cream flex items-center justify-center p-8">
      <div className="w-full max-w-md">
        <div className="text-center mb-12">
          <div className="logo-badge mx-auto mb-6">
            <img src="/assets/wolf-logo.png" alt="Wolf Media" style={{ height: 64 }} />
          </div>
          <p className="font-body text-xs uppercase tracking-[0.3em] text-text-secondary">Accounting System</p>
        </div>
        
        <form onSubmit={handleLogin} className="bg-surface border border-border p-8">
          <h2 className="font-heading text-2xl font-light mb-8 text-text-primary">Sign In</h2>
          
          {error && (
            <div data-testid="login-error" className="mb-6 p-3 bg-maroon/10 border border-maroon/20 text-maroon text-sm">
              {error}
            </div>
          )}
          
          <div className="mb-6">
            <label className="block font-body text-xs uppercase tracking-[0.2em] text-text-secondary mb-2">
              Email
            </label>
            <input
              data-testid="login-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-transparent border border-border focus:border-maroon outline-none p-3 font-body text-base transition-colors"
              required
            />
          </div>
          
          <div className="mb-8">
            <label className="block font-body text-xs uppercase tracking-[0.2em] text-text-secondary mb-2">
              Password
            </label>
            <input
              data-testid="login-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-transparent border border-border focus:border-maroon outline-none p-3 font-body text-base transition-colors"
              required
            />
          </div>
          
          <button
            data-testid="login-submit-button"
            type="submit"
            disabled={loading}
            className="w-full bg-maroon text-white hover:bg-maroon-hover px-6 py-3 font-heading text-lg transition-colors duration-200 disabled:opacity-50"
          >
            {loading ? 'Signing In...' : 'Sign In'}
          </button>
        </form>
        
        <div className="mt-8 text-center">
          <p className="font-body text-xs text-text-secondary">wolfmedia.in</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
